// Root level redirects from citsci.org/${redirect}
// Ensure that these do not conflict with any other routes in the router/index.js file

// Wait so that we dont drop into the 404 page before the redirect happens

export default [
  {
    name: "mscolorado",
    path: "/mscolorado",
    redirect: (to) => {
      const url =
        "https://blog.citsci.org/2026/06/18/walk-with-us-caroline-nickerson-brings-citizen-science-to-the-park-hill-4th-of-july-parade-as-ms-doctorate-colorado-2026/";
      console.log(`Redirecting to ${url}`);
      window.location = url;
      return { path: "/" };
    },
  },
];
